var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6v2C7 8 7 9 6 9S5 8 4 8V6 5c1-1 1-1 2-1s1 0 2 1v1zm0 0L7 5H6 5L4 6c0 1 1 1 1 1 0 1 1 1 1 1s1 0 1-1c0 0 1 0 1-1z",
    fill: "#696871"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10c1-1 2-2 2-4 0-1-1-3-2-4-1 0-1-1-2-1H4C3 1 3 2 2 2 1 3 0 5 0 6c0 2 1 3 2 4l1 1 2 2c1 1 2 1 2 0l2-2 1-1zM3 3c0-1 1-1 1-1 1 0 1-1 2-1s1 1 2 1c0 0 1 0 1 1 1 1 2 2 2 3s-1 3-1 3l-1 1-1 1-1 1H6v0H5l-2-2-1-1S1 7 1 6s1-2 2-3z",
    fill: "#696871"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.dae69f04eb7d873282762f34b2e82591.svg";
export { ForwardRef as ReactComponent };